var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74283 19C2.23058 19 1 17.7694 1 16.2572C1 14.7449 2.23058 13.5143 3.74283 13.5143C5.25507 13.5143 6.48537 14.7449 6.48537 16.2572C6.48537 17.7694 5.25535 19 3.74283 19ZM3.74283 14.6343C2.84796 14.6343 2.11998 15.3623 2.11998 16.2572C2.11998 17.152 2.84796 17.88 3.74283 17.88C4.63769 17.88 5.36539 17.152 5.36539 16.2572C5.36539 15.3623 4.63769 14.6343 3.74283 14.6343Z",
    fill: "#16161D",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8172 5.36567C18.0227 5.36567 19 4.38838 19 3.18284C19 1.97729 18.0227 1 16.8172 1C15.6116 1 14.6343 1.97729 14.6343 3.18284C14.6343 4.38838 15.6116 5.36567 16.8172 5.36567Z",
    fill: "#16161D",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3154 5.58127L11.8881 6.23141L12.5786 6.92188L6.1687 13.3321L6.56461 13.728L12.9745 7.31779L13.6653 8.00854L14.3154 5.58127Z",
    fill: "#16161D",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.412 5.60714L14.4568 5.43987L14.2895 5.48467L11.8623 6.13482L11.6949 6.17964L11.8174 6.30213L12.4372 6.92188L6.09798 13.2614L6.02728 13.3321L6.09799 13.4028L6.4939 13.7987L6.56461 13.8694L6.63532 13.7987L12.9745 7.45922L13.5946 8.07925L13.717 8.20174L13.7619 8.03441L14.412 5.60714ZM0.9 16.2572C0.9 17.8247 2.17535 19.1 3.74283 19.1C5.3106 19.1 6.58537 17.8246 6.58537 16.2572C6.58537 14.6897 5.31032 13.4143 3.74283 13.4143C2.17535 13.4143 0.9 14.6897 0.9 16.2572ZM2.21998 16.2572C2.21998 15.4175 2.90319 14.7343 3.74283 14.7343C4.58244 14.7343 5.26539 15.4175 5.26539 16.2572C5.26539 17.0968 4.58244 17.78 3.74283 17.78C2.90319 17.78 2.21998 17.0968 2.21998 16.2572ZM16.8172 5.46567C18.0779 5.46567 19.1 4.44361 19.1 3.18284C19.1 1.92206 18.0779 0.9 16.8172 0.9C15.5564 0.9 14.5343 1.92206 14.5343 3.18284C14.5343 4.44361 15.5564 5.46567 16.8172 5.46567Z",
    stroke: "#16161D",
    strokeOpacity: 0.65,
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdFlowIcon);
export default __webpack_public_path__ + "static/media/odFlowIcon.472213099c1e59da2ecc544ed356299c.svg";
export { ForwardRef as ReactComponent };